import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLightRegularRightIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.825 8.413a.6.6 0 0 0 0-.848l-5-5a.6.6 0 0 0-.848.848l4.576 4.575-4.575 4.575a.6.6 0 0 0 .848.848l4.999-5.001z",
		fill: "currentColor"
	})
});
export default SvgChevronLightRegularRightIcon;
